var map = {
	"./BPI-France.png": 6888,
	"./MIT.png": 3114,
	"./Region-IDF.png": 1092,
	"./ce-logo-normandie.png": 9090,
	"./fiance-brussels.png": 9164,
	"./tedxparis-logo.png": 5299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3714;